import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Link, useLocation } from 'react-router-dom';

export default function HeaderEducationSelector({ educationTypes, selectedEducationType }) {
  const location = useLocation();
  const [headerHost, setHeaderHost] = useState(null);

  useEffect(() => {
    const root = document.getElementById('root') || document.body;
    const locateHeader = () => {
      const nextHost = document.querySelector('.header .header-right') || document.querySelector('.header .header-content');
      setHeaderHost((current) => current === nextHost ? current : nextHost);
    };
    locateHeader();
    const observer = new MutationObserver(locateHeader);
    observer.observe(root, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [location.pathname]);

  if (!headerHost) return null;
  const facultyTypeId = location.state?.faculty?.education_type_id;
  const educationSlug = location.pathname.match(/^\/education\/([^/]+)/)?.[1];
  const routeType = educationSlug && Array.isArray(educationTypes)
    ? educationTypes.find((type) => String(type.name || '')
      .toLocaleLowerCase('tr-TR')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/ı/g, 'i').replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '') === educationSlug)
    : null;
  const selectedId = facultyTypeId || routeType?.id || selectedEducationType;
  const current = Array.isArray(educationTypes)
    ? educationTypes.find((type) => String(type.id) === String(selectedId))
    : null;

  return createPortal(
    <div className="education-type-selector ebs-header-education-selector">
      <Link to="/education-types" aria-label="Eğitim türü seçimi" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
        <div className="header-education-select">{current?.name || 'Eğitim Türü Seçin'}</div>
      </Link>
    </div>,
    headerHost
  );
}
